<template>
  <footer>
    <div class="footer-images">
      <a href="https://demos.co.uk/">
        <img alt="demos logo" class="demos-logo" src="../assets/demos-logo.png"/>
      </a>
    <a href="https://brand.legalandgeneral.com/building-infrastructure/how-satisfied-are-people-in-your-area">
      <img
        alt="legal and general logo"
        class="lg-logo"
        src="../assets/legal-and-general-logo-white.png"
      />
    </a>
    </div>
    <div class="footer-links">
      <a href="https://demos.co.uk/about/contact/">
        Contact Us
      </a>
      <p class="link-divider">|</p>
      <a href="https://demos.co.uk/privacy-policy/">
        Privacy Policy
      </a>
    </div>
  </footer>
</template>

<script>

  export default {
    name: "Footer"
  };

</script>

<style scoped>

  footer {
    background-color: #1d3336;
    border-top: 1px solid black;
    padding: 2rem;
  }

  .footer-images {
    display: flex;
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;      /* TWEENER - IE 10 */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    margin-top: 1rem;
  }

  .footer-links {
    margin: 0.5rem auto 1rem auto;
    font-size: 0.9rem;
    display: flex;
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;      /* TWEENER - IE 10 */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
    justify-content: center;
    align-items: center;
  }

  .footer-links a {
    color: white;
    text-decoration: none;
  }
  .demos-logo {
    background-color: #1d3336;
    height: 1.5rem;
  }

  .lg-logo {
    background-color: #1d3336;
    height: 3rem;
  }
  
  .link-divider {
    color: white; 
    margin: 0 0.5rem;
  }

</style>